var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"down"},[(_vm.showTip)?_c('img',{staticClass:"tip",attrs:{"src":require("@/assets/images/wx_download_tip.png"),"alt":""}}):_vm._e(),_c('div',{staticClass:"download-button",on:{"click":_vm.down}},[_vm._v("立即下载")])])}
var staticRenderFns = []

export { render, staticRenderFns }